import { render } from "./ModalNominal.vue?vue&type=template&id=66d574a6&ts=true"
import script from "./ModalNominal.vue?vue&type=script&lang=ts"
export * from "./ModalNominal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__